// src/config/oauthProviders.ts (Example file)
import { OAuthProviderConfig } from '../models/oauthProviderConfig';

export const gitHubProvider: OAuthProviderConfig = {
  providerName: 'GitHub',
  apiCallbackPath: '/auth/github/callback',
  // "http://127.0.0.1:9001/auth/github/callback"; // for use with REST API server
  // "http://127.0.0.1:5001/deriqai-2025/us-central1/fn/auth/github/callback"; // for use with firebase functions
};

export const googleProvider: OAuthProviderConfig = {
  providerName: 'Google',
  apiCallbackPath: '/auth/google/callback',
  // "http://127.0.0.1:9001/google/callback"; // for use with REST API server
  // "http://127.0.0.1:5001/deriqai-2025/us-central1/fn/google/callback"; // for use with firebase functions
};

// Add LinkedIn, Azure etc. when ready
// export const linkedInProvider: OAuthProviderConfig = {
//   providerName: 'LinkedIn',
//   apiCallbackPath: '/linkedin/callback',
// };
